import type { ConfigType } from '@plone/registry';
import type { BlockConfigBase } from '@plone/types';
import installSettings from './config/settings';
import SeminarListing from './components/Blocks/Listing/SeminarListing';
import SeminarView from './components/theme/View/SeminarView';
import CartBlock from './components/Blocks/Cart';
import CartFieldWrapper from './components/Blocks/Cart/CartFieldWrapper';
import CartAwareFormView from './components/Blocks/CartAwareFormView';
import withFormWidth, { type FormSchema } from './components/Blocks/FormSchema';
import CartSchema from './components/Blocks/Cart/schema';
import SafeSelectFacet from './components/Blocks/Search/SafeSelectFacet';
import DefaultEditBlock from '@plone/volto/components/manage/Blocks/Block/DefaultEdit';
import DateRangeFacet from './customizations/@plone/volto/components/manage/Blocks/Search/components/DateRangeFacet';

import formSVG from '@plone/volto/icons/form.svg';

declare module '@plone/types' {
  export interface BlocksConfigData {
    cart: BlockConfigBase;
  }
}

type FormBlockConfig = BlockConfigBase & {
  additionalFields?: Array<Record<string, unknown>>;
  formSchema: FormSchema;
};

function applyConfig(config: ConfigType) {
  installSettings(config);

  config.views.contentTypesViews.seminar = SeminarView;

  config.blocks.blocksConfig.cart = {
    id: 'cart',
    title: 'Warenkorb',
    icon: formSVG,
    group: 'common',
    view: CartBlock,
    edit: DefaultEditBlock,
    blockSchema: CartSchema,
  };

  const formBlockConfig = config.blocks.blocksConfig.form as FormBlockConfig;

  formBlockConfig.view = CartAwareFormView;
  formBlockConfig.formSchema = withFormWidth(formBlockConfig.formSchema);
  formBlockConfig.additionalFields = [
    ...(formBlockConfig.additionalFields || []),
    {
      id: 'cart',
      label: 'Warenkorb',
      component: CartFieldWrapper,
      isValid: () => true,
    },
  ];

  config.blocks.blocksConfig.listing.variations = [
    ...config.blocks.blocksConfig.listing.variations,
    {
      id: 'seminare',
      title: 'Seminare',
      fullobjects: true,
      template: SeminarListing,
    },
  ];

  const facetWidgets =
    config.blocks.blocksConfig.search.extensions.facetWidgets;

  facetWidgets.types = facetWidgets.types.map((facetWidget) =>
    facetWidget.id === 'selectFacet'
      ? { ...facetWidget, view: SafeSelectFacet }
      : facetWidget.id === 'daterangeFacet'
        ? { ...facetWidget, view: DateRangeFacet }
        : facetWidget,
  );

  return config;
}

export default applyConfig;
